import React, { useEffect, useState } from "react";
import Header from "../Header";
import WelcomeBack from "../WelcomeBack";
import FormIntro from "../FormIntro";
import { Routes, Route } from "react-router-dom";
import ApplicationForm from "../ApplicationForm";
import Review from "../Review";
import Submission from "../Submission";
import Terms from "../Terms";
import Queries from "../Queries";
import LoggedQueries from "../Queries/LoggedQueries";
import { useSelector, useDispatch } from "react-redux";
import { GetBaseUrl } from "../modules/getBaseUrl";
import SubmittedWelcome from "../SubmittedStatus";
import ApplicationPreview from "../ApplicationPreview";
import DropoutFarewell from "../FarewellScreen";
import KnowledgeSection from "../KnowledgeSection";
import ImpactSurvey from "../ImpactSurvey";
import DSPolicy from "../DataSharingPolicy";
import {
  addTokenInfo,
  doLogout,
  initiateTimer,
  migrateInfo,
} from "../LoginPage/redux/actions";
import ModalComponent from "../modules/Modal";
import Button from "../modules/Button";
import { useHistory } from "react-router-dom";
import DisburseForm from "../DisburseForm";
import DisburseReview from "../DisburseReview";
import LetterProof from "../LetterProof";
import { api } from "../../Services";
import { useNavigate } from "react-router-dom";
import { clearDisburse, modifySpoc } from "../DisburseForm/redux/actions";
import {
  incTimerData,
  isSet,
  resetTimerData,
  setTasksData,
  setTimerData,
} from "./redux/actions";
import Connect from "../Connect";
import AlumniScreen from "../AlumniLoggedScreen";
import PreAwarded from "../PreAwarded";
import { addMentorInfo, resetClear } from "../Connect/redux/actions";
import { resetState } from "../PersonalInfo/redux/actions";
import { resetIncome } from "../IncomeDetails/redux/actions";
import { resetEdu } from "../Education/redux/actions";
import { resetRegister } from "../Register/redux/actions";
import { resetApp, showNotified } from "../ApplicationForm/redux/actions";
import { resetQueries } from "../Queries/redux/actions";
import { resetStatus } from "../WelcomeBack/redux/actions";
import { GetLogout } from "../modules/Logout";

function IdfcBackground(props) {
  const tokenData = useSelector((state) => state.tokens.tokens);
  const navigate = useNavigate();
  // const history = useHistory();
  // const { action, length, location } = history;
  const dispatch = useDispatch();
  const set = useSelector((state) => state.timer.set);
  const [partialData, setPartialData] = useState(tokenData.token);
  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const notifications = useSelector((state) => state.connect.notifications);
  const [Link, setLink] = useState("");
  const docs = useSelector((state) => state.tokens.tokens.docs);
  const [timeLimit, setTimeLimit] = useState(0);
  const [warning, setWarning] = useState(25);
  const [logoutTime, setLogoutTime] = useState(30);
  // const [seconds, setSeconds] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const registeredData = useSelector((state) => state.register.registeredData);
  const timer = useSelector((state) => state.timer);

  const [ModalData, setModalData] = useState({
    show: false,
    type: "confirm",
    title: "Session Timed out. Please try again",
    countDown: " ",
    desc: "",
  });
  const checkLogin = () => {
    if (!tokenData.token) {
      let url = GetBaseUrl(window.location.href);
      // window.location.replace(url);
      navigate("/");
      // console.log("islogged");
    }
  };

  // const startTimer = () => {
  //   dispatch(initiateTimer());

  //   setTimeout(() => {
  //     // dispatch(timerFinished());
  //     alert("30 minutes timer finished.");
  //   }, 30 * 60 * 1000);
  // };
  const getScholar = async () => {
    let data = {
      program: null,
      batch: null,
      college: null,
    };
    try {
      const scholarData = await api.getAlumni(
        tokenData.token,
        false,
        tokenData.applicationData.id,
        data
      );

      if (scholarData.statusCode == 200) {
        dispatch(
          addMentorInfo({
            type: "scholars",
            value: scholarData.data ? [...scholarData.data] : [],
          })
        );
      }
      console.log("scholarData", scholarData);
    } catch (err) {
      console.log("err", err);
    }
  };

  const setRefreshToken = async () => {
    try {
      let refreshToken = { refreshToken: tokenData?.refreshToken };
      console.log("refreshToken", refreshToken);
      const docs2 = await api.getToken(refreshToken);
      console.log("refreshToken", docs2);
      if (docs2) {
        dispatch(addTokenInfo(["token", docs2.data.token]));
        dispatch(addTokenInfo(["refreshToken", docs2.data.refreshToken]));
      }
    } catch (err) {
      console.log("err", err);
    }
  };
  const getLogout = async () => {
    // const personalInfo = useSelector((state) => state.personal.personalInfo);
    // const dispatch = useDispatch();
    // const tokenData = useSelector((state) => state.tokens.tokens);

    try {
      let users = await api.logout(tokenData.token, personalInfo?.mobile);
      console.log("logout api", users);
      // if (users.statusCode == 200) {
      dispatch(resetState());
      dispatch(resetIncome());
      dispatch(resetEdu());
      dispatch(resetRegister());
      dispatch(resetApp());
      dispatch(resetQueries());
      dispatch(resetStatus());
      dispatch(clearDisburse());
      dispatch(resetClear());
      dispatch(doLogout());
      // }
      return users;
    } catch (error) {
      console.error("Error logging out:", error);

      //   } finally {
      // setIsLoading(false);
    }
  };
  const resetTimer = async () => {
    if (ModalData.type === "confirm") {
      setIsRunning(false);
      dispatch(setTasksData(1));
      // setSeconds(0);
      dispatch(resetTimerData());

      setRefreshToken();
      setTimeout(() => setIsRunning(true), 2000);
      setModalData({ ...ModalData, show: false });
    } else {
      // dispatch(doLogout());
      let users = await getLogout();
      console.log("logout api", users);
      setModalData({ ...ModalData, show: false });
    }
  };
  const getSpocs = async (data) => {
    try {
      const result = await api.getSpoc(
        tokenData.token,
        tokenData.applicationData.id
      );
      console.log("result", result);
      return result;
    } catch (err) {
      console.log("err", err);
      // setErr({ showErr: true, errText: err.message });
    }
  };

  const getSpocData = async () => {
    try {
      const result = await getSpocs();
      console.log("result", result);
      dispatch(modifySpoc(["firstName", result?.data?.spocInfo?.firstName]));
      dispatch(modifySpoc(["lastName", result?.data?.spocInfo?.lastName]));
      dispatch(modifySpoc(["email", result?.data?.spocInfo?.email]));
      dispatch(modifySpoc(["mobile", result?.data?.spocInfo?.phone]));
      dispatch(modifySpoc(["campus", result?.data?.campusName]));

      return result;
    } catch (err) {
      console.log("err", err);
      // setErr({ showErr: true, errText: err.message });
    }
  };
  const getNotifications = async () => {
    try {
      const notifyData = await api.getNotifications(
        tokenData.token,
        tokenData.applicationData.id
      );

      if (notifyData.statusCode == 200) {
        let data = notifyData.data
          ? [
              ...notifyData.data?.sort((a, b) => a?.id - b?.id).reverse(),
            ]?.slice(0, 10)
          : [];
        if (notifications !== data) {
          dispatch(showNotified(true));
        }
        dispatch(addMentorInfo({ type: "notifications", value: data }));
      }
      // if (mentorData.data) {
      //   dispatch(addMentorInfo([...mentorData.data]));
      // }
      console.log("notifyData", notifyData);
    } catch (err) {
      console.log("err", err);
    }
  };
  const getAlumni = async () => {
    let data = {
      program: null,
      batch: null,
      college: null,
    };
    try {
      const alumniData = await api.getAlumni(
        tokenData.token,
        true,
        tokenData.applicationData.id,
        data
      );

      if (alumniData.statusCode == 200) {
        dispatch(
          addMentorInfo({
            type: "alumnis",
            value: alumniData.data ? [...alumniData.data] : [],
          })
        );
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const logoutMsg = async () => {
    let users = await getLogout();
    console.log("logout api", users);
    console.log("u have been logged out");
  };
  useEffect(() => {
    getScholar();
    getAlumni();
    getNotifications();
    getSpocData();
    setIsRunning(true);

    let currentUrl = window.location.href;
    const cleanedUrl = currentUrl.replace(/^https?:\/\/(www\.)?/, "");
    setPartialData(
      partialData.slice(0, 30) + partialData[13] + partialData.slice(30 + 1)
    );
    setLink(cleanedUrl);
  }, []);
  useEffect(() => {
    console.log();
    if (timer.timer > 25 * 60 && timer.timer < 30 * 60) {
      setModalData({
        ...ModalData,
        show: true,
        type: "confirm",
        title: "Are you there ?",
      });
    } else if (timer.timer > 30 * 60) {
      console.log("logged out", timer.timer);
      // dispatch(doLogout());
      logoutMsg();
    }
  }, [timer.timer]);

  useEffect(() => {
    let timerId;

    if (isRunning) {
      let newTime = timer.timer + 1;
      // console.log("timer.timer in ueh", timer.timer, newTime);
      timerId = setInterval(() => {
        dispatch(incTimerData());
      }, 1000);
    } else {
      clearInterval(timerId);
    }

    // Cleanup function to clear the interval when component unmounts or isRunning becomes false
    return () => clearInterval(timerId);
  }, [isRunning]);

  useEffect(() => {
    if (set) {
      dispatch(migrateInfo(["token", partialData]));
    }
  }, [set]);
  useEffect(() => {
    // setTimeout(() => setTimeLimit((prev) => prev + 1), 1000);

    console.log(" tokenData.startTime", tokenData);
  }, [timeLimit]);

  useEffect(() => {
    checkLogin();
  }, [tokenData.token]);

  return (
    <>
      {Link.split("/")[2] !== "proof-letter" && <Header />}
      <Routes>
        <Route path="/" element={<FormIntro />} />
        <Route path="status" element={<WelcomeBack />} />
        <Route path="pre-awarded" element={<PreAwarded />} />
        {/* <Route path="alumni-profile" element={<UserProfi />} /> */}

        <Route path="submitted-status" element={<SubmittedWelcome />} />
        <Route path="alumni/*" element={<AlumniScreen />} />
        <Route path="disburse-form/*" element={<DisburseForm />} />
        <Route path="proof-letter" element={<LetterProof />} />
        <Route path="disburse-review" element={<DisburseReview />} />
        <Route path="app-preview/*" element={<ApplicationPreview />} />
        <Route path="drop-fare" element={<DropoutFarewell />} />
        <Route path="knowledge" element={<KnowledgeSection />} />
        <Route path="impact" element={<ImpactSurvey />} />
        <Route path="policy" element={<DSPolicy />} />
        <Route path="help/*" element={<LoggedQueries isLoggedin={true} />} />
        <Route path="connect/*" element={<Connect />} />
        <Route path="/review" element={<Review />} />
        <Route path="/form/*" element={<ApplicationForm />} />
        <Route path="/submission" element={<Submission />} />
        <Route path="*" element={<FormIntro />} />
      </Routes>

      {/* {Link.split("/")[2] === "submitted-status" && (
      
      )} */}
      {ModalData.show && (
        <ModalComponent
          show={ModalData.show}
          handleClose={() => {}}
          noCross={true}
          title={ModalData.title}
          className="timeout-model"
          content={ModalData.desc}
          type={ModalData.type}
          countDown={ModalData.countDown}
        >
          <div className="modal-btn-set">
            <Button
              onClickHandler={() => resetTimer()}
              type={"contained"}
              value={ModalData.type === "confirm" ? "Yes" : "Ok"}
            />
            {/* <Button
              onClickHandler={() => {}}
              type={"contained "}
              value={"No"}
            /> */}
          </div>
        </ModalComponent>
      )}
    </>
  );
}

export default IdfcBackground;
